import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./Login.css";
import {
  Alert,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Skeleton,
  Stack,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../../redux/actions/user-action";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiGet, apiPost } from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import MarkEmailUnreadRoundedIcon from "@mui/icons-material/MarkEmailUnreadRounded";
import DangerousRoundedIcon from "@mui/icons-material/DangerousRounded";

const LOGO = require("../../assets/images/logo.png");
const LOGIN_BG = require("../../assets/images/login-bg-01.png");
const LOADER = require("../../assets/images/Loading_icon.gif");

const myStyles = makeStyles({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    // height: "40px",
    // "& * > input": {
    //   padding: "5px !important",
    // },
    // "& > div": {
    //   padding: "10px !important",
    // },
    // padding: "5px !important"
  },
  signinbtn: {
    backgroundColor: "rgb(6 98 59) !important",
    border: 0,
    color: "white !important",
    height: 48,
    padding: "0 30px",
  },
  logoImage: {
    width: "70px !important",
    // height: "10px !important",
    marginBottom: "20px",
  },
  loginBtn: {
    backgroundColor: "#06623B !important",
    marginTop: "15px !important",
    color: "white !important",
    // "&:hover": {
    //   backgroundColor: "#06623B",
    // },
  },
});

const ChangePassword = () => {
  const theme = createTheme();
  const classes = myStyles();
  const { id } = useParams();

  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
    showNewPassword: false,
    showConfirmPassword: false,
  });

  const [isLoading, setIsLoading] = useState({
    loadingResponse: false,
    snackbarLoading: false,
    checkToken: false,
  });

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  const handleChangeNewPassword = (e) => {
    const { value } = e.target;
    setPasswords({
      ...passwords,
      newPassword: value,
    });
  };

  const handleChangeConfirmPassword = (e) => {
    const { value } = e.target;
    setPasswords({
      ...passwords,
      confirmPassword: value,
    });
  };

  const handleRedirect = () => {
    navigate('/login');
  };

  const handleClickShowNewPassword = () => {
    setPasswords({
      ...passwords,
      showNewPassword: !passwords.showNewPassword,
    });
  };

  const handleMouseDownNewPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowConfirmPassword = () => {
    setPasswords({
      ...passwords,
      showConfirmPassword: !passwords.showConfirmPassword,
    });
  };

  const handleMouseDownConfirmPassword = (event) => {
    event.preventDefault();
  };

  const onSubmitChangePassword = () => {
    if (passwords.newPassword === passwords.confirmPassword) {
      var dataObj = passwords.newPassword;
      apiPost(
        ApiEndpoints.resetPassword + `/${id}`,
        { password: dataObj },
        (res) => {
          setSuccess(true);
          setInterval(() => {
            navigate('/login');
            // window.location.href = "/login";
          }, 3000);
        },
        (err) => {
         // console.log("err", err);
        }
      );
    } else {
      setError(true);

      setInterval(() => {
        setError(false);
      }, 5000);
    }
  };

  useEffect(() => {
    apiGet(
      ApiEndpoints.verifyResetToken + `${id}`,
      (res) => {
        setIsLoading({ ...isLoading, loadingResponse: true });
        // if (res == true || res == false) {
        //   setIsLoading({ ...isLoading, loadingResponse: false });
        // }
        if (res == false) {
          // setIsLoading(true);
          setIsLoading({ ...isLoading, checkToken: true });
        }
      },
      (err) => {
      //  console.log("err", err);
      }
    );
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />

        {isLoading.loadingResponse ? (
          <Grid item container xs={6} sm={6} md={6}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              alignItems="center"
              justifyContent="center"
              display="flex"
            >
              <Stack
                justifyContent="center"
                // display="flex"
                alignItems="stretch"
                height="100%"
                sx={{ margin: "auto" }}
                spacing={2}
              >
                <Box>
                  <Box>
                    <img className={classes.logoImage} src={LOGO} />
                  </Box>
                  <Typography variant="h5" fontWeight={600} gutterBottom>
                    Reset Password
                  </Typography>
                  {/* <Typography variant="body2">
                    Your new password must be different to previously used
                    passwords
                  </Typography> */}
                  <Box mt={2}>
                    <Typography variant="body2">New Password</Typography>
                    <TextField
                      error={error ? true : false}
                      //   helperText={
                      //     inputErrors.emailError ? inputErrors.emailErrMsg : ""
                      //   }
                      type={passwords.showNewPassword ? "text" : "password"}
                      margin="normal"
                      value={passwords.newPassword}
                      className={classes.outlineInputBorder}
                      required
                      fullWidth
                      autoFocus
                      onChange={handleChangeNewPassword}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowNewPassword}
                              onMouseDown={handleMouseDownNewPassword}
                              edge="end"
                            >
                              {passwords.showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <Typography
                      variant="body2"
                      // fontSize={20}
                      // fontWeight={400}
                      // color="#1E293B"
                    >
                      Confirm Password
                    </Typography>
                    <TextField
                      error={error ? true : false}
                      type={passwords.showConfirmPassword ? "text" : "password"}
                      margin="normal"
                      className={classes.outlineInputBorder}
                      required
                      fullWidth
                      autoFocus
                      onChange={handleChangeConfirmPassword}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowConfirmPassword}
                              onMouseDown={handleMouseDownConfirmPassword}
                              edge="end"
                            >
                              {passwords.showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <LoadingButton
                      sx={{ mt: 5, borderRadius: 5 }}
                      fullWidth
                      //   loading={inputErrors.loginSpin ? true : false}
                      variant="contained"
                      onClick={onSubmitChangePassword}
                      className={classes.loginBtn}
                    >
                      Submit
                    </LoadingButton>
                    {error && (
                      <Alert sx={{ mt: 2 }} severity="error">
                        Please enter same password
                      </Alert>
                    )}
                    {success && (
                      <Alert sx={{ mt: 2 }} severity="success">
                        Your Password Successfully Changed
                      </Alert>
                    )}
                  </Box>

                  {/* {inputError && (
                 <Alert variant="filled" severity="error">
                   {passwordErrorMessage}
                   {emailErrorMessage}
                 </Alert>
               )} */}
                </Box>
              </Stack>
              {/* </Grid>
             </Grid> */}
            </Grid>
          </Grid>
        ) : (
          <Grid item container xs={6} sm={6} md={6}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              alignItems="center"
              justifyContent="center"
              display="flex"
            >
              {isLoading.checkToken ? (
                <Stack
                  justifyContent="center"
                  // display="flex"
                  alignItems="stretch"
                  height="100%"
                  sx={{ margin: "auto" }}
                  spacing={2}
                >
                  <Box>
                    <Box>
                      <img className={classes.logoImage} src={LOGO} />
                    </Box>
                    <DangerousRoundedIcon
                      sx={{ fontSize: 70, color: "#C70039" }}
                    />
                    <Typography variant="h5"> Something went wrong</Typography>
                    <Box mt={2}>
                      <Typography>
                        We couldn't find the link for resetting your password
                      </Typography>
                    </Box>
                    <Button
                      className={classes.loginBtn}
                      onClick={handleRedirect}
                      variant="outlined"
                    >
                      Back to Login
                    </Button>
                  </Box>
                </Stack>
              ) : (
                <Grid item container xs={6} sm={6} md={6}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                  >
                    <Stack
                      justifyContent="center"
                      // display="flex"
                      alignItems="stretch"
                      height="100%"
                      sx={{ margin: "auto" }}
                      spacing={2}
                    >
                      <img src={LOADER} width="250px" />
                    </Stack>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}

        {/* Right Column */}
        <Grid
          item
          xs={false}
          sm={6}
          md={6}
          direction="column"
          // alignItems="center"
          justifyContent="center"
          display="flex"
          sx={{
            backgroundImage: `url(${LOGIN_BG})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Box sx={{ margin: "auto" }}>
            <Box>
              <Typography
                variant="caption"
                fontSize="35px"
                // gutterBottom
                fontWeight={50}
                color={"#FFF"}
              >
                Welcome to
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="h3"
                component="h2"
                gutterBottom
                color={"#FFF"}
                fontWeight={700}
              >
                Legends Golf Tour
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default ChangePassword;
